import type { ReactNode } from "react";

type Props = {
  title?: string;
  children: ReactNode;
  className?: string;
};

// Soft red error panel — matches the portal's inline error pattern
// (see Launcher.tsx). Use for surfaced API errors near the action that
// caused them; for transient toast feedback use the Toast provider.
export function ErrorAlert({
  title = "Something went wrong",
  children,
  className = "",
}: Props) {
  return (
    <div
      role="alert"
      className={`rounded-card border border-red-200 bg-red-50 p-4 text-sm text-red-800 ${className}`.trim()}
    >
      <p className="font-semibold">{title}</p>
      <div className="mt-1 text-red-800">{children}</div>
    </div>
  );
}
